import React from 'react';
import { Card, Typography } from 'antd';
import PropTypes from 'prop-types';

import ControlledLexicalEditor from './ControlledLexicalEditor';

const { Title } = Typography;

/**
 * GlobalNotesEditor - Editor for global notes that apply across all strategies
 *
 * This is a presentational component that receives content and onChange
 * from the parent. All state management is handled by useStrategyEditor.
 */
export default function GlobalNotesEditor({
    content,
    contentVersion,
    onChange,
    isSaving,
    isReadOnly = false
}) {
    return (
        <div className="global-notes-editor">
            <Card
                title={<Title level={3}>Global TradeBook</Title>}
                extra={isSaving ? <span className="saving-indicator">Saving...</span> : null}
            >
                <ControlledLexicalEditor
                    content={content}
                    contentVersion={contentVersion}
                    onChange={onChange}
                    isReadOnly={isReadOnly}
                    placeholder="Enter your trading philosophy, universal rules, and general guidelines that apply across all strategies..."
                    minHeight="400px"
                />
            </Card>
        </div>
    );
}

GlobalNotesEditor.propTypes = {
    content: PropTypes.string,
    contentVersion: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    isSaving: PropTypes.bool,
    isReadOnly: PropTypes.bool
};
